import axios, { AxiosInstance } from 'axios';
import API_CONFIG from '../config/apiConfig';

// Get dynamic API base URL
const getApiBaseUrl = (): string => {
  return API_CONFIG.BASE_URL || API_CONFIG.getApiUrl() || 'http://localhost:3000/api';
};

const api: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Update the base URL dynamically when it changes
if (typeof window !== 'undefined') {
  const updateBaseUrl = () => {
    const newBaseUrl = getApiBaseUrl();
    if (newBaseUrl && api.defaults.baseURL !== newBaseUrl) {
      api.defaults.baseURL = newBaseUrl;
      console.log('[API Service] Updated base URL to:', newBaseUrl);
    }
  };
  
  updateBaseUrl();
  window.addEventListener('popstate', updateBaseUrl);
}

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Track if we're already redirecting to prevent loops
let isRedirecting = false;

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isRedirecting) {
      // TEMPORARY: Disable redirect for debugging
      console.error('401 from main API config - NOT REDIRECTING', {
        url: error.config?.url,
        error: error.response?.data
      });
    }
    return Promise.reject(error);
  }
);

// Helper function to get auth header
export const getAuthHeader = () => {
  const token = localStorage.getItem('authToken') || localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export default api;